export const isPhotoResolutionValid = ({
	minWidth,
	minHeight,
	photoWidth,
	photoHeight,
}) => {
	if (photoWidth < minWidth) {
		return false;
	}
	if (photoHeight < minHeight) {
		return false;
	}
	return true;
};
